export default __webpack_public_path__ + "static/media/loader_new.4be6a40d.svg";